import * as React from "react";
import PropTypes from 'prop-types';

const SvgPromotionMessage = props => {
  if (props.id !== "_svgpromotionmessage") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M26.778 12.544a2.745 2.745 0 103.886-3.877 2.745 2.745 0 00-3.886 3.877zM20.91 5l12.222.056a1.11 1.11 0 011.111 1.11V18.39L19.367 33.31a3.332 3.332 0 01-4.7 0l-8.69-8.7a3.334 3.334 0 010-4.7L20.89 5h.022z" /></svg>;
};

SvgPromotionMessage.displayName = "_svgpromotionmessage";
SvgPromotionMessage.propTypes = {
  id: PropTypes.string
};
SvgPromotionMessage.defaultProps = {
  id: ''
};
export default SvgPromotionMessage;